import React from 'react'
import { useQueryClient } from 'react-query'

import { DeactivateButton } from 'components/configurations/common/DeactivateButton'
import useAuth from 'hooks/use-auth'
import { agentsQueryKeys } from 'queries/agents/query-keys'
import { useDeleteClients } from 'queries/clients/use-delete-clients'
import { usePostFailureFlagsAppsProtect } from 'queries/failure-flags/use-post-failure-flags-apps-protect'
import { type Agent, AgentType } from 'types/api/agents/agents'
import {
  clientsIdActivatePut,
  failureFlagsAppsUnprotectPost
} from 'utils/endpoints-access'

export const DeactivateAgentButton: React.FC<{
  agent: Agent
  onConfirm?: () => void
}> = ({ agent, onConfirm }) => {
  const { currentTeamId: teamId } = useAuth()
  const queryClient = useQueryClient()

  const { id, type } = agent

  const isInfrastructureAgent = type === AgentType.INFRASTRUCTURE

  const apiProp = isInfrastructureAgent
    ? clientsIdActivatePut
    : failureFlagsAppsUnprotectPost

  const mutationHookDeactivateAgent = isInfrastructureAgent
    ? useDeleteClients
    : usePostFailureFlagsAppsProtect

  const { mutateAsync: mutateDeactivateAgent } = mutationHookDeactivateAgent(id)

  const handleSuccess = async () => {
    if (onConfirm) {
      onConfirm()
    }

    await queryClient.invalidateQueries(agentsQueryKeys.get({ teamId }))
    await queryClient.invalidateQueries(agentsQueryKeys.getSummary({ teamId }))
  }

  return (
    <DeactivateButton
      apiProp={apiProp}
      dialogTitle="Deactivate Agent"
      id={id}
      onConfirmRequest={mutateDeactivateAgent}
      onSuccess={handleSuccess}
    />
  )
}
